import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from "../Auth/LoginButton";
import { Button } from "react-bootstrap";

export default function MembershipJoin() {
  const { isAuthenticated } = useAuth0();
  const heading = "Membership";
  const description = (
    <p>
      By joining the Liberty Connect network, you will gain access to valuable
      resources and connect with industry professionals who share your
      commitment to excellence. Our platform fosters collaboration and knowledge
      sharing, empowering you to become a future leader in the real estate
      industry.
    </p>
  );
  const betaOffer = isAuthenticated ? (
    <>
      <p>
        Congratulations! Thank you for participating in our beta release. You
        qualify for a <b>FREE 1-year membership</b>.
      </p>
    </>
  ) : (
    <>
      <p>
        <b>Exclusive Beta Offer: Get 1 Year Free Membership!</b>
      </p>
      <p>
        Membership starts in April, but sign up during our beta release to get
        full access now—and receive a <b>FREE 1-year membership</b> when we
        launch!
      </p>
    </>
  );
  const callToAction = isAuthenticated
    ? "Free Membership"
    : "Sign Up - Free Trial";
  const callToActionTag = isAuthenticated ? "Expires March 2026" : "";
  return (
    <div className="membership-join">
      <div className="membership-content">
        <h1>{heading}</h1>
        <div>
          {description}
          {betaOffer}
        </div>
        <div>
          {isAuthenticated ? (
            <Button>{callToAction}</Button>
          ) : (
            <LoginButton
              className="btn btn-primary"
              returnTo="/property-search"
              signup
              buttonLabel={callToAction}
            />
          )}
          <div>
            <small>{callToActionTag}</small>
          </div>
        </div>
      </div>
    </div>
  );
}
